module.exports = __webpack_public_path__ + "img/competence_icon_support.10426e4.svg";